/* @flow */
const isSSR = typeof window === 'undefined' || import.meta.env.SSR

const stubStorage = key => ({
  async set(value) {
    return value
  },
  async get() {
    return undefined
  },
  async remove() {},
})

export default key => {
  if (isSSR) return stubStorage(key)
  const storageKey = key
  return {
    async set(value) {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(value))
      } catch (err) {
        console.error('Unable to store data. Error: ', err)
      }
      return value
    },

    async get() {
      try {
        const raw = window.localStorage.getItem(storageKey)
        if (raw == null || raw === 'undefined') return undefined
        return JSON.parse(raw)
      } catch (error) {
        console.warn(`Error parsing stored value for key "${storageKey}"`)
        throw error
      }
    },

    async remove() {
      window.localStorage.removeItem(storageKey)
    },
  }
}
